import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Gift, ChevronRight } from 'lucide-react';
const bonos = [{
  id: 'B1',
  title: 'Banco de Combinaciones Listas',
  description: '50 combinaciones de pasos por ritmo organizadas por dificultad, con descripción paso a paso y listas para insertar en cualquier clase. Nunca más te quedás sin ideas en el medio de una clase.'
}, {
  id: 'B2',
  title: 'Guía de Corrección Postural y Técnica',
  description: 'Los errores más comunes por ritmo, cómo corregirlos sin interrumpir la clase, lenguaje de corrección positivo y prevención de lesiones en ritmos latinos.'
}, {
  id: 'B3',
  title: 'Clases Express de 30 Minutos',
  description: '8 clases completas de 30 minutos listas para usar. Formato compacto sin perder estructura. Ideal para gimnasios con horarios ajustados.'
}, {
  id: 'B4',
  title: 'Guía de Comunicación con Alumnos',
  description: 'Frases motivadoras por momento de clase, cómo dar indicaciones claras mientras bailás, manejo de alumnos difíciles o desmotivados y cómo generar pertenencia en tu grupo.'
}, {
  id: 'B5',
  title: 'Rutinas de Calentamiento Especializadas',
  description: '12 calentamientos completos listos. Específicos para movilidad de caderas y columna. Progresión de intensidad clara y adaptables a cualquier ritmo.'
}, {
  id: 'B6',
  title: 'Guía de Inicio Rápido',
  description: 'Cómo leer y usar los tomos, por dónde empezar según tu situación actual, checklist de implementación semana a semana y respuestas a las dudas más frecuentes del instructor.'
}];
export function BonusesSlider() {
  const [expandedId, setExpandedId] = useState<string | null>(null);
  return <section className="py-12 md:py-24 bg-neutral-950 border-t border-neutral-800" data-id="element-21">
      <div className="container mx-auto px-4 mb-6 md:mb-12 text-center" data-id="element-22">
        <span className="inline-block py-1 px-2.5 md:px-3 rounded-full bg-amber-500/20 text-amber-400 font-bold text-[10px] md:text-sm mb-2 md:mb-4 border border-amber-500/30" data-id="element-23">
          Sin costo extra — incluidos en todas las ofertas
        </span>
        <h2 className="text-2xl md:text-5xl font-black text-white mb-1 md:mb-4" data-id="element-24">
          INCLUIDOS GRATIS
        </h2>
        <p className="text-sm md:text-xl text-neutral-400" data-id="element-25">
          6 Bonos Estratégicos
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-4" data-id="element-26">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6" data-id="element-27">
          {bonos.map(bono => {
          const isExpanded = expandedId === bono.id;
          return <motion.div key={bono.id} layout onClick={() => setExpandedId(isExpanded ? null : bono.id)} className={`cursor-pointer rounded-xl md:rounded-2xl border transition-colors duration-300 ${isExpanded ? 'col-span-2 lg:col-span-1 bg-gradient-to-br from-neutral-900 to-neutral-950 border-amber-500/50 shadow-[0_0_30px_rgba(245,158,11,0.15)]' : 'bg-neutral-900 border-neutral-800 hover:border-neutral-700'}`} data-id="element-28">
                <div className="p-3.5 md:p-8" data-id="element-29">
                  <div className="flex justify-between items-start mb-3 md:mb-6" data-id="element-30">
                    <div className="flex items-center gap-2 md:gap-3" data-id="element-31">
                      <div className={`flex items-center justify-center w-8 h-8 md:w-10 md:h-10 rounded-lg font-black text-xs md:text-lg ${isExpanded ? 'bg-amber-500 text-neutral-950' : 'bg-neutral-800 text-neutral-400'}`} data-id="element-32">
                        {bono.id}
                      </div>
                      <Gift className={`w-4 h-4 md:w-6 md:h-6 ${isExpanded ? 'text-amber-500' : 'text-neutral-600'}`} data-id="element-33" />
                    </div>
                    <span className="px-1.5 py-0.5 md:px-2 md:py-1 bg-green-500/20 text-green-400 text-[10px] md:text-xs font-bold rounded uppercase tracking-wider" data-id="element-34">
                      GRATIS
                    </span>
                  </div>

                  <h3 className={`font-bold mb-1 text-sm md:text-xl leading-snug ${isExpanded ? 'text-lg md:text-2xl text-white' : 'text-neutral-200'}`} data-id="element-35">
                    {bono.title}
                  </h3>

                  <AnimatePresence data-id="element-36">
                    {isExpanded && <motion.div initial={{
                  opacity: 0,
                  height: 0
                }} animate={{
                  opacity: 1,
                  height: 'auto'
                }} exit={{
                  opacity: 0,
                  height: 0
                }} transition={{
                  duration: 0.3
                }} className="overflow-hidden" data-id="element-37">
                        <p className="text-neutral-300 mt-4 leading-relaxed" data-id="element-38">
                          {bono.description}
                        </p>
                      </motion.div>}
                  </AnimatePresence>

                  {!isExpanded && <div className="mt-2 md:mt-4 text-xs md:text-sm font-medium text-amber-500 flex items-center gap-1" data-id="element-39">
                      Ver detalle{' '}
                      <ChevronRight className="w-3 h-3 md:w-4 md:h-4" data-id="element-40" />
                    </div>}
                </div>
              </motion.div>;
        })}
        </div>
      </div>

      <div className="text-center mt-6 md:mt-12" data-id="element-41">
        <p className="text-lg md:text-3xl font-black text-white" data-id="element-42">
          VALOR TOTAL DE LOS 6 BONOS{' '}
          <span className="text-neutral-500 line-through decoration-red-500" data-id="element-43">
            $56.000
          </span>{' '}
          — <span className="text-green-400" data-id="element-44">GRATIS</span>
        </p>
        <p className="text-neutral-400 text-xs md:text-base mt-1 md:mt-2" data-id="element-45">
          Incluidos siempre
        </p>
      </div>
    </section>;
}